import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import ScaleImg from "../../images/location/atlanta/scale-up.png";

function Scale(props) {
    return (
        <div className="scale p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="scale-img">
                            <LazyLoadImage
                                src={ScaleImg}
                                effect="blur" alt="Tab_01" className="img-fluid pioneer-img"
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="scale-content">
                           <h2>Work with a Top App Development Company with the Best App Developers in Seattles</h2>
                            <p>We continuously innovate our development processes according to the evolution of technologies in this field. That’s what keeps us achieving new landmarks in the tech industry. With our diverse mobile app solutions, we have a credible reputation in Seattle.</p>
                            <p>You can consult with our professionals and they will guide you with multiple options to digitize your business in the best manner. We have such expert Seattle WA mobile app developers in our team that do wonders with their systematic approach. That’s the reason, we have facilitated many businesses with their digital growth.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Scale;